<template>
    <v-container class="fade-in">
        <v-layout data-app wrap row>
        <v-flex xs9 class="align-self-center">
            <v-text-field v-model="term" label="Search" class="mx-4"></v-text-field>
        </v-flex>
        <v-flex xs3 class="align-self-center">
            <v-btn color="primary" dark @click="onSearchClicked" class="align-start" small>Search</v-btn>
        </v-flex>
    </v-layout>
    <v-layout data-app wrap row>
        <v-flex xs12>
            <v-data-table
                :headers="headers"
                :items="rowData"
                item-key="id"
                @click:row="onRowDoubleClicked"
                class="elevation-1"
                ></v-data-table>
        </v-flex>
    </v-layout>
    </v-container>
</template>

<script>
// @ is an alias to /src
import router from "@/router";
import { officeManagementService } from "@/services/officeManagementService";

export default {
  name: "AdminOfficeSearch",
  data: () => ({
    headers: [
      { text: "Agency", value: "agency", align: "start" },
      { text: "Program", value: "program" },
      { text: "Field", value: "field" },
      { text: "Branch", value: "branch" },
      { text: "Description", value: "description" },
      { text: "Survey Type", value: "surveyType" }
    ],
    rowData: [],
    term: null
  }),
  methods: {
    onSearchClicked () {
        const me = this;
        officeManagementService.searchForOffice()
            .then(function (response) {
                me.rowData = response.data.results;
            })
            .catch(function (err) {
                console.error(err);
            });
    },
    onRowDoubleClicked (value) {
        console.log(value);
        router.push({ name: 'details', params: { id: value.id, surveyId: 11 } });
    }
  }
};
</script>

<style scoped>
</style>
